'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

var _ThemeManager = require('@/libs/ThemeManager');

var _ThemeManager2 = _interopRequireDefault(_ThemeManager);

var _GlobalApi = require('@/libs/GlobalApi');

var _GlobalApi2 = _interopRequireDefault(_GlobalApi);

var _SettingsAliases = require('./SettingsAliases');

var _SettingsAliases2 = _interopRequireDefault(_SettingsAliases);

var _SettingsAdvanced = require('./SettingsAdvanced');

var _SettingsAdvanced2 = _interopRequireDefault(_SettingsAdvanced);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function bindSetting(settingName) {
    return {
        get: function settingGetter() {
            return this.state.setting(settingName);
        },
        set: function settingSetter(newVal) {
            this.state.setting(settingName, newVal);
        }
    };
}

exports.default = {
    components: {
        SettingsAliases: _SettingsAliases2.default,
        SettingsAdvanced: _SettingsAdvanced2.default
    },
    data: function data() {
        return {
            state: _state2.default,
            theme: '',
            customThemeUrl: '',
            pluginUiElements: _GlobalApi2.default.singleton().appSettingsPlugins
        };
    },
    computed: {
        themeSupportsMonospace: function themeSupportsMonospace() {
            var themeMgr = _ThemeManager2.default.instance();
            var val = themeMgr.themeVar('supports-monospace');
            return val === '1';
        },
        timestamps_24h: {
            get: function get24Timestamps() {
                return _state2.default.setting('buffers.timestamp_format').substr(0, 2) === '%H';
            },
            set: function set24Timestamps(newVal) {
                var newFormat = newVal ? '%H:%M:%S' : '%l:%M:%S';
                _state2.default.setting('buffers.timestamp_format', newFormat);
            }
        },
        settings: function getSettings() {
            return _state2.default.settings;
        },
        settingShowAutoComplete: bindSetting('showAutocomplete'),
        settingUseMonospace: bindSetting('useMonospace'),
        settingHighlights: bindSetting('highlights'),
        settingBufferColourNicknames: bindSetting('buffers.colour_nicknames_in_messages'),
        settingBufferShowTimestamps: bindSetting('buffers.show_timestamps'),
        settingBufferShowEmoticons: bindSetting('buffers.show_emoticons'),
        settingBufferBlockPms: bindSetting('buffers.block_pms'),
        settingBufferScrollbackSize: bindSetting('buffers.scrollback_size'),
        settingBufferExtraFormatting: bindSetting('buffers.extra_formatting'),
        settingBufferTrafficAsActivity: bindSetting('buffers.traffic_as_activity'),
        settingBufferMuteSound: bindSetting('buffers.mute_sound'),
        settingDefaultBanMask: bindSetting('buffers.default_ban_mask'),
        settingDefaultKickReason: bindSetting('buffers.default_kick_reason'),
        settingAdvancedEnable: {
            get: function getSettingShowAdvancedTab() {
                return _state2.default.ui.show_advanced_tab;
            },
            set: function setSettingShowAdvancedTab(newVal) {
                _state2.default.ui.show_advanced_tab = newVal;
            }
        },
        messageLayouts: function messageLayouts() {
            return {
                traditional: 'compact',
                modern: 'modern',
                inline: 'inline'
            };
        },

        settingMessageLayout: {
            set: function setSettingMessageLayout(newVal) {
                var l = this.messageLayouts;
                _state2.default.setting('buffers.messageLayout', l[newVal] || l.modern);
            },
            get: function get() {
                var s = _state2.default.setting('buffers.messageLayout');
                var l = _lodash2.default.invert(this.messageLayouts);
                return l[s];
            }
        }
    },
    created: function created() {
        this.listenForThemeSettings();
    },
    methods: {
        closeSettings: function closeSettings() {
            _state2.default.$emit('active.component');
        },
        refreshTheme: function refreshTheme() {
            _ThemeManager2.default.instance().reload();
        },
        listenForThemeSettings: function listenForThemeSettings() {
            var _this = this;

            var themeMgr = _ThemeManager2.default.instance();
            var watches = [];

            var updateFn = function updateFn() {
                var theme = themeMgr.currentTheme();
                _this.theme = theme.name;
                _this.customThemeUrl = theme.name === 'custom' ? theme.url : '';
            };

            var watchTheme = function watchTheme(newVal) {
                themeMgr.setTheme(newVal);
            };

            var watchCustomThemeUrl = function watchCustomThemeUrl(newVal) {
                if (themeMgr.currentTheme().name === 'custom') {
                    themeMgr.setCustomThemeUrl(newVal);
                }
            };

            var teardownFn = function teardownFn() {
                _this.state.$off('theme.change', updateFn);
                watches.forEach(function (unwatchFn) {
                    return unwatchFn();
                });
                _this.$off('hook:destroy', teardownFn);
            };

            updateFn();

            this.state.$on('theme.change', updateFn);
            this.$once('hook:destroyed', teardownFn);

            watches = [this.$watch('theme', watchTheme), this.$watch('customThemeUrl', watchCustomThemeUrl)];
        },
        enableAdvancedTab: function enableAdvancedTab() {
            var _this2 = this;

            this.settingAdvancedEnable = true;
            this.$nextTick(function () {
                _this2.$refs.tabs.setActiveByName('advanced');
                _this2.$el.scrollTop = 0;
            });
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["AppSettings"]
window._kiwi_exports.components.AppSettings = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppSettings.vue
// module id = BTvu
// module chunks = 1